import styled from 'styled-components';

export const Icon = styled.span<{ type: string }>`
  background-image: url(${({ type }) => type});
  width: 16px;
  height: 20px;
  display: inline-block;
  background-size: cover;
`;
